
<template>
    <div class="d-flex flex-column mt-2" style="height: 100%">
        <div class="d-flex flex-column flex-md-row mt-2">
            <v-container fluid>
                <div class="text-xs-center mt-3 mb-3">
                    <v-row justify="center">
                        <v-col md="8" sm="5" v-if="pending" type="warning" offset-md="3">
                                <transition name="alert">
                                    <v-alert type="warning" :width="isMobile ? '400' : '400'">
                                        You have a pending data correction application
                                    </v-alert>
                                </transition>
                        </v-col>


                        <v-col cols="12" lg="5" v-else>
                            <v-form v-model="dataValid">
                                <v-col>
                                    <v-select
                                        outlined
                                        dense
                                        v-model="data.type"
                                        :items="[
                                                {
                                                    value: 1,
                                                    text: 'NAME'
                                                },

                                                {
                                                    value: 2,
                                                    text: 'NATIONALITY'
                                                },

                                                {
                                                    value: 3,
                                                    text: 'STATE',
                                                },

                                                {
                                                    value: 4,
                                                    text: 'LGA'
                                                },

                                                {
                                                    value: 5,
                                                    text: 'PHONE'
                                                },

                                                {
                                                    value: 6,
                                                    text: 'OTHER(OR MULTIPLE)'
                                                }
                                        ]"
                                        item-value="value"
                                        item-text="text"
                                        label="Select Change"
                                        placeholder="Select">
                                    </v-select>
                                </v-col>


                                <v-col>
                                    <v-textarea
                                        outlined
                                        dense
                                        v-model="data.currentData"
                                        required
                                        :rules="textRules"
                                        placeholder="Current">

                                    </v-textarea>
                                </v-col>

                                <v-col>
                                    <v-textarea
                                        outlined
                                        v-model="data.newData"
                                        required
                                        dense
                                        :rules="textRules"
                                        placeholder="New">
                                    </v-textarea>
                                </v-col>

                                <v-col>
                                    <v-btn
                                        type="primary"
                                        color="primary"
                                        depressed
                                        :disabled="!dataValid"
                                        @click="saveUpdatedInfo"
                                        class="px-4">
                                        Update
                                    </v-btn>
                                </v-col>
                            </v-form>
                        </v-col>
                    </v-row>
                </div>
          </v-container>
        </div>
        <loading-dialog :show="loading"></loading-dialog>
        <message-box :show="messageShow" :message="message" :type="messageType" v-on:close-message="messageShow = !messageShow"></message-box>
    </div>
</template>



<script >
import { mapGetters, mapActions } from 'vuex';
import LoadingDialog from '@ui/components/LoadingDialog.vue';
import MessageBox from '@ui/components/MessageBox.vue';
import Api from '@/main/api';
import DataCorrection from '@/shared/apis/dataCorrection';
import DataConstant from "@/shared/constants/DataCorrections";
import ValidationRules from '@/shared/ValidationRules';
import ErrorResolver from '@/shared/ErrorResolver';




export default {
    name: "CurrentChange",
    components: {
        LoadingDialog,
        MessageBox,

    },


    data: () => ({
        messageShow: false,
        dataValid: true,
        loading: false,
        message: '',
        messageType: '',
        pending: null,
        changed: null,
        textRules: ValidationRules.textRules,
        entities: [],
        info: [],
        data: {
            userId: '',
            type: '',
            newData: '',
            currentData: ''
        },


    }),

    methods: {
        saveUpdatedInfo() {
            this.loading = true;
            this.pending = null;
            this.data.userId = this.getUser.userId
            Api.dataCorrection.apply(this.data).then((res) => {
                this.messageType = 'warning';
                this.message = "Application Pending"
                this.messageShow = true;
                this.pending = res.data;
            }).catch((err) => {
                ErrorResolver.checkErrors(this, err);

            }).finally(() => {
                this.loading = false;
            })
        },

        checkPending() {
            if(this.getUser != null){
                this.loading = true;
                this.pending = null;
                Api.dataCorrection.fetchPending(this.getUser.userId).then((res) => {
                    if(this.pending != null){
                        return this.pending = res.data;
                    }

                }).catch((err) => ErrorResolver.checkErrors(this, err))
                .finally(() => {
                    this.loading = false;
                })
            }

        }

    },


    computed: {
        isMobile: function() {
            return this.$vuetify.breakpoint.xs
        },

       ...mapGetters(['getUser'])
    },


    watch: {
        getUser: function(val){
            if(!val){
                this.data.userId = val.userId;
                this.checkPending();
            }
        },
    },

    created() {
        if(this.getUser != null){
            this.checkPending();
        }
    }
}

</script>
